import { useMediaQuery } from '@/hooks/useMediaQuery'
import { ResponsiveParams } from './lib/types'
import { useMemo } from 'react'
import { useWindowSize } from '@/hooks/useWindowSize'

const responsivePresets = {
  sm: {
    blockSize: 10,
    blocksPerRegion: 8,
    regionsAcross: 0,
    regionsDown: 2,
  },
  md: {
    blockSize: 15,
    blocksPerRegion: 8,
    regionsAcross: 0,
    regionsDown: 2,
  },
  lg: {
    blockSize: 15,
    blocksPerRegion: 8,
    regionsAcross: 0,
    regionsDown: 6,
  },
  xl: {
    blockSize: 15,
    blocksPerRegion: 8,
    regionsAcross: 0,
    regionsDown: 5,
  },
  '2xl': {
    blockSize: 15,
    blocksPerRegion: 8,
    regionsAcross: 0,
    regionsDown: 5,
  },
}

export function useResponsiveParams(
  containerRef: React.RefObject<HTMLDivElement | null>,
): ResponsiveParams | null {
  const { width } = useWindowSize()
  const containerWidth = useMemo(() => containerRef.current?.clientWidth, [width])

  // Add media query hooks
  const is2xl = useMediaQuery('(min-width: 1536px)')
  const isXl = useMediaQuery('(min-width: 1280px)')
  const isLg = useMediaQuery('(min-width: 1024px)')
  const isMd = useMediaQuery('(min-width: 768px)')

  const preset = is2xl
    ? responsivePresets['2xl']
    : isXl
      ? responsivePresets.xl
      : isLg
        ? responsivePresets.lg
        : isMd
          ? responsivePresets.md
          : responsivePresets.sm

  if (!containerWidth) {
    return null
  }

  const regionSize = preset.blockSize * preset.blocksPerRegion
  const optimalRegionsAcross = Math.floor(containerWidth / regionSize)

  return {
    ...preset,
    regionsAcross: optimalRegionsAcross,
    width: optimalRegionsAcross * regionSize,
    height: preset.regionsDown * regionSize,
  }
}
